import { createArray } from "@/utils/utility";

import { Box, Card, CardContent, Stack, Typography } from "@mui/material";
import {
  areIntervalsOverlapping,
  endOfMonth,
  format,
  isSameSecond,
  setMonth,
  startOfMonth,
  startOfSecond,
  startOfYear,
} from "date-fns";
import PropTypes from "prop-types";

import CalendarCard from "./CalendarCard";

function MonthsView({ yearlyHolidays, viewDate, setHoliday, getGoTo }) {
  return (
    <Box
      sx={{
        display: "grid",
        gridTemplateColumns: "repeat(auto-fill, minmax(min(16rem, 100%), 1fr))",
        gap: 1,
      }}
    >
      {createArray(0, 12).map((item) => {
        const currentMonth = setMonth(startOfYear(viewDate), item);
        const monthlyHolidays = yearlyHolidays.filter(
          (holiday) =>
            areIntervalsOverlapping(
              { start: startOfMonth(currentMonth), end: endOfMonth(currentMonth) },
              { start: holiday.start, end: holiday.end },
            ) && !isSameSecond(startOfSecond(holiday.end), startOfMonth(currentMonth)),
        );

        return (
          <Card key={item}>
            <CardContent>
              <Stack
                sx={{
                  gap: 1,
                }}
              >
                <Typography variant="h5" component="h4" sx={{ m: 0 }}>
                  {format(currentMonth, "MMMM")}
                </Typography>
                <Stack
                  sx={{
                    gap: 0.5,
                  }}
                >
                  {monthlyHolidays.length >= 1 ? (
                    monthlyHolidays.map((holiday) => (
                      <CalendarCard
                        key={holiday.id}
                        holiday={holiday}
                        viewDate={currentMonth}
                        onClick={() => setHoliday(holiday)}
                        getGoTo={getGoTo}
                      />
                    ))
                  ) : (
                    <Stack
                      direction="row"
                      sx={{
                        gap: 1,
                        justifyContent: "space-between",
                        alignItems: "center",
                      }}
                    >
                      <Typography variant="body2">No holidays</Typography>
                    </Stack>
                  )}
                </Stack>
              </Stack>
            </CardContent>
          </Card>
        );
      })}
    </Box>
  );
}

MonthsView.propTypes = {
  yearlyHolidays: PropTypes.array,
  viewDate: PropTypes.number,
  setHoliday: PropTypes.func,
  getGoTo: PropTypes.func,
};

export default MonthsView;
